export default __webpack_public_path__ + "static/media/Research.51ae8784.png";